export default "__VITE_ASSET__CMXD4L3U__"